const eu28 = require('./eu28.png');
const eu27_2020 = require('./eu28.png');
const at = require('./at.png');
const be = require('./be.png');
const bg = require('./bg.png');
const ch = require('./ch.png');
const cy = require('./cy.png');
const cz = require('./cz.png');
const de = require('./de.png');
const dk = require('./dk.png');
const ee = require('./ee.png');
const el = require('./el.png');
const es = require('./es.png');
const fi = require('./fi.png');
const fr = require('./fr.png');
const hr = require('./hr.png');
const hu = require('./hu.png');
const ie = require('./ie.png');
const is = require('./is.png');
const it = require('./it.png');
const lt = require('./lt.png');
const lu = require('./lu.png');
const lv = require('./lv.png');
const me = require('./me.png');
const mt = require('./mt.png');
const nl = require('./nl.png');
const no = require('./no.png');
const pl = require('./pl.png');
const pt = require('./pt.png');
const ro = require('./ro.png');
const rs = require('./rs.png');
const se = require('./se.png');
const si = require('./si.png');
const sk = require('./sk.png');
const uk = require('./uk.png');

const images = {
    eu28,
    eu27_2020,
    at,
    be,
    bg,
    ch,
    cy,
    cz, 
    de, 
    dk, 
    ee,
    el, 
    es,
    fi,
    fr,
    hr,
    hu,
    ie,
    is,
    it,
    lt,
    lu,
    lv,
    me,
    mt,
    nl,
    no,     
    pl,
    pt,
    ro,
    rs,
    se,
    si,
    sk,
    uk
}

export default images